/** `MomentumTaskStatus` as Omega spells it on the wire. */
export const MOMENTUM_TASK_STATUS_VALUES = [
  "not_started",
  "in_progress",
  "done",
  "closed",
] as const;

export type MomentumTaskStatus = (typeof MOMENTUM_TASK_STATUS_VALUES)[number];

export const MOMENTUM_TASK_STATUS_LABEL_KEYS: Record<MomentumTaskStatus, string> = {
  not_started: "momentumTaskSettings.status.notStarted",
  in_progress: "momentumTaskSettings.status.inProgress",
  done: "momentumTaskSettings.status.done",
  closed: "momentumTaskSettings.status.closed",
};

/** `MomentumTaskPriority` as Omega spells it on the wire. */
export const MOMENTUM_TASK_PRIORITY_VALUES = ["low", "medium", "high"] as const;

export type MomentumTaskPriority = (typeof MOMENTUM_TASK_PRIORITY_VALUES)[number];

export const MOMENTUM_TASK_PRIORITY_LABEL_KEYS: Record<MomentumTaskPriority, string> = {
  low: "momentumTaskSettings.priority.low",
  medium: "momentumTaskSettings.priority.medium",
  high: "momentumTaskSettings.priority.high",
};

export function isMomentumTaskStatus(value: string): value is MomentumTaskStatus {
  return (MOMENTUM_TASK_STATUS_VALUES as readonly string[]).includes(value);
}

export function isMomentumTaskPriority(value: string): value is MomentumTaskPriority {
  return (MOMENTUM_TASK_PRIORITY_VALUES as readonly string[]).includes(value);
}

export type MomentumTaskEnumKind = "status" | "priority";

export interface MomentumTaskEnumOption {
  value: string;
  labelKey: string;
}

/** Every wire value Omega accepts for the enum, in display order. */
export function momentumTaskEnumOptions(kind: MomentumTaskEnumKind): MomentumTaskEnumOption[] {
  return kind === "status"
    ? MOMENTUM_TASK_STATUS_VALUES.map((value) => ({
        value,
        labelKey: MOMENTUM_TASK_STATUS_LABEL_KEYS[value],
      }))
    : MOMENTUM_TASK_PRIORITY_VALUES.map((value) => ({
        value,
        labelKey: MOMENTUM_TASK_PRIORITY_LABEL_KEYS[value],
      }));
}

/** The label key for a wire value, or `undefined` when Omega would reject it. */
export function momentumTaskEnumLabelKey(
  kind: MomentumTaskEnumKind,
  value: string
): string | undefined {
  if (kind === "status") {
    return isMomentumTaskStatus(value) ? MOMENTUM_TASK_STATUS_LABEL_KEYS[value] : undefined;
  }
  return isMomentumTaskPriority(value) ? MOMENTUM_TASK_PRIORITY_LABEL_KEYS[value] : undefined;
}
